// ======================================================================
// InventoryLedgerPage.jsx
// PPE → Inventory → Reports → Inventory Ledger
// ======================================================================

import React, { useState } from "react";
//import { fetchInventoryLedger } from "./inventoryLedgerService";
import {
  fetchInventoryLedger,
  exportInventoryLedgerExcel
} from "./inventoryLedgerService";


import ERPReportLayout from
"../../../../components/reports/ERPReportLayout";

import ERPFilterBar from
"../../../../components/reports/ERPFilterBar";

import ERPDataGrid from
"../../../../components/reports/ERPDataGrid";

import ERPReportActions from
"../../../../components/reports/ERPReportActions";

import "../../../../components/reports/reportStyles.css";

import MasterSearchSelect from
"../../../../../../components/common/MasterSearchSelect";

import SearchableDropdown from "../../../../components/common/SearchableDropdown";
import warehouseLookupService from "../stock-register/warehouseLookupService";


export default function InventoryLedgerPage() {

  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);

  const [filters, setFilters] = useState({
    materialType: "",
    materialId: "",
    materialLabel: "",
    warehouse: "",
    warehouseLabel: "",
    batch: "",
    fromDate: "",
    toDate: ""
  });

  // --------------------------------------------------
  // LOAD DATA
  // --------------------------------------------------
  const loadData = async () => {
    setLoading(true);
    try {
      const data = await fetchInventoryLedger(filters);
      setRows(data.rows || []);
    } finally {
      setLoading(false);
    }
  };

  // --------------------------------------------------
  // EXPORT HANDLER
  // --------------------------------------------------
  const handleExport = async (format) => {

  try {

    if (format !== "xlsx") {
      alert("PDF export not implemented yet");
      return;
    }

    const blob =
      await exportInventoryLedgerExcel(filters);

    const url =
      window.URL.createObjectURL(
        new Blob([blob])
      );

    const link =
      document.createElement("a");

    link.href = url;

    link.setAttribute(
      "download",
      "inventory_ledger.xlsx"
    );

    document.body.appendChild(link);

    link.click();

    link.remove();

  } catch (err) {

    console.error(err);

    alert(
      "Failed to export report"
    );
  }
};
  // --------------------------------------------------
  // GRID COLUMN CONFIG (ERP STANDARD)
  // --------------------------------------------------
  const columns = [
  {
    key: "date",
    label: "Date",
    render: r => r.date?.slice(0, 10)
  },
  {
    key: "transaction_no",
    label: "Txn No",
    bold: true
  },
  {
    key: "transaction_type",
    label: "Type"
  },
  {
    key: "reference_type",
    label: "Module"
  },
  {
    key: "material_code",
    label: "Material Code"
  },
  {
    key: "material_name",
    label: "Material Name"
  },
  {
    key: "warehouse_name",
    label: "Warehouse",
    render: r =>
      `${r.warehouse_code || ""} - ${r.warehouse_name || ""}`
  },
  {
    key: "batch_no",
    label: "Batch",
    render: r => r.batch_no || "-"
  },
  {
    key: "uom_name",
    label: "UOM"
  },
  {
    key: "qty_in",
    label: "Qty In",
    align: "right",
    render: r => Number(r.qty_in || 0).toFixed(2)
  },
  {
    key: "qty_out",
    label: "Qty Out",
    align: "right",
    render: r => Number(r.qty_out || 0).toFixed(2)
  },
  {
    key: "balance",
    label: "Balance",
    align: "right",
    bold: true,
    render: r => Number(r.balance || 0).toFixed(2)
  },
  {
    key: "unit_rate",
    label: "Rate",
    align: "right",
    render: r => Number(r.unit_rate || 0).toFixed(2)
  },
  {
    key: "value",
    label: "Value",
    align: "right",
    render: r => Number(r.value || 0).toFixed(2)
  },
  {
    key: "posting_status",
    label: "Status"
  }
];

  // --------------------------------------------------
  // FILTER BAR
  // --------------------------------------------------
  const filterBar = (
    <ERPFilterBar
      left={
        <>
          <select
            className="erp-filter"
            onChange={e =>
              setFilters(prev => ({
                ...prev,
                materialType: e.target.value
              }))
            }
          >
            <option value="">All Types</option>
            <option value="RAW_MATERIAL">Raw Material</option>
            <option value="BOUGHTOUT">Bought Out</option>
          </select>

          {/* ✅ Searchable Material Select (NEW - SAFE ADDITION) */}
          <MasterSearchSelect
            type="material"
            materialType={filters.materialType}
            placeholder="Search Material..."
            onChange={(item) =>
              setFilters(prev => ({
                ...prev,
                materialId: item?.id || "",
                materialLabel:
                  item?.material_name ||
                  item?.item_name ||
                  ""
              }))
            }
          />

          {/* ✅ Existing Manual Input (KEPT — fallback) */}
          


          <SearchableDropdown
  label=""
  value={filters.warehouseLabel}
  placeholder="Search Warehouse..."
  fetchOptions={warehouseLookupService.search}
  getOptionLabel={(o) =>
    `${o.warehouse_code} - ${o.warehouse_name}`
  }
  onChange={(v) =>
    setFilters(prev => ({
      ...prev,
      warehouseId: v.id,
      warehouseLabel:
        `${v.warehouse_code} - ${v.warehouse_name}`
    }))
  }
/>

          <input
            placeholder="Batch"
            className="erp-filter"
            onChange={e =>
              setFilters(prev => ({
                ...prev,
                batch: e.target.value
              }))
            }
          />

          <input
            type="date"
            className="erp-filter"
            onChange={e =>
              setFilters(prev => ({
                ...prev,
                fromDate: e.target.value
              }))
            }
          />

          <input
            type="date"
            className="erp-filter"
            onChange={e =>
              setFilters(prev => ({
                ...prev,
                toDate: e.target.value
              }))
            }
          />

          <button
            onClick={loadData}
            className="erp-primary-btn"
          >
            Load
          </button>
        </>
      }

      right={
        <div className="flex items-center gap-4">
          <ERPReportActions onExport={handleExport} />
        </div>
      }
    />
  );

  // =====================================================
  // UI
  // =====================================================
  return (
    <ERPReportLayout
      title="Inventory Ledger"
      subtitle="Complete transaction audit trail"
      toolbar={filterBar}
    >

      <ERPDataGrid
        columns={columns}
        rows={rows}
        loading={loading}
        height="600px"
      />

    </ERPReportLayout>
  );
}
